module.exports = __webpack_public_path__ + "img/bicycle-red.f792f9b7.svg";